import { render, staticRenderFns } from "./ViStudentAttendanceView.vue?vue&type=template&id=50371f65&scoped=true"
import script from "./ViStudentAttendanceView.vue?vue&type=script&lang=js"
export * from "./ViStudentAttendanceView.vue?vue&type=script&lang=js"
import style0 from "./ViStudentAttendanceView.vue?vue&type=style&index=0&id=50371f65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50371f65",
  null
  
)

export default component.exports